<template>
  <div class="footer-box">
    <div class="container">
      <p class="sign"><img style="width:136px" src="../../image/home/logo-white.png" alt=""></p>
      <div class="line"></div>
      <h1 class="title" v-html="footerInfo.title"></h1>
      <p class="text">{{ footerInfo.text }}</p>
    </div>
    <div class="copyright">
      <span class="text1">Copyright © {{(new Date()).getFullYear()}}, Geekbang Technology Ltd. All rights reserved. <br v-if="isMobile"/>极客邦控股（北京）有限公司</span>
      <span class="text2">京 ICP 备 16027448 号 - 5</span>
      <div class="beian-box">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502039052">
          <img src="../../assets/img/beian.png" alt="京公网安备" />
          <p>京公网安备 11010502039052号</p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['footerInfo'],
  computed: {
    ...mapState(['isMobile'])
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/app.sass';
.footer-box {
  color: #fff;
  background-color: rgba(37, 42, 58, 1);
  >.container {
    display: flex;
    flex-direction: column;
    padding-bottom: 25px;
    .sign {
      display: flex;
      align-items: center;
      font-size: 14px;
      margin: 18px 0;
    }
    .line {
      height: 1px;
      background-color: #80868A;
    }
    .title {
      font-size: 32px;
      font-weight: 500;
      margin: 30px 0 19px 0;
      @include mobile {
        margin: 15px 0 10px 0;
        font-size: 26px;
      }
    }
    .text {
      color: rgba(255, 255, 255, 0.6);
      font-size: 14px;
    }
  }
  .copyright {
    padding: 10px 0;
    display: flex;
    justify-content: center;
    font-size: 12px;
    // color: rgba(250, 250, 250, 0.4);
    color: #3C4043;
    background: #fff;
    @include mobile {
      flex-direction: column;
      align-items: center;
    }

    .text1 {
      @include mobile {
        text-align: center;
      }
    }

    .beian-box {
      margin-left: 20px;
      @include mobile {
        margin-left: 0;
      }
      &>a {
        display: flex;
        font-size: 12px;
        // color: rgba(250, 250, 250, 0.4);
        color: #3C4043;
        &>p {
          margin-left: 5px;
        }
      }
    }
  }
}
</style>
